import { ClickAwayListener, IconButton } from '@mui/material';
import { GrammerlyCustomLinearIcon } from '../../icons-lib';
import { Popper } from '@mui/base/Popper';
import EmojiPicker from 'emoji-picker-react';
import { useRef, useState } from 'react';

const EmojiPickerButton = ({ onClick, variant }) => {
    const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);
    const emojiButtonRef = useRef(null);

    const handleEmojiClick = (emojiObject) => {
        onClick(emojiObject.emoji);
        setIsEmojiPickerOpen(false);
    };
    const outlinestyle = {
        padding: '12px 14px',
        height: '48px',
        borderRadius: '8px',
        border: '1px solid #D0D5DD'
    };
    return (
        <div>
            <IconButton
                ref={emojiButtonRef}
                sx={variant === 'outlined' ? outlinestyle : {}}
                onClick={() => setIsEmojiPickerOpen(!isEmojiPickerOpen)}
            >
                <GrammerlyCustomLinearIcon />
            </IconButton>

            <Popper
                open={isEmojiPickerOpen}
                anchorEl={emojiButtonRef.current}
                placement="bottom-start"
            >
                <ClickAwayListener
                    onClickAway={() => setIsEmojiPickerOpen(false)}
                >
                    <div>
                        <EmojiPicker
                            onEmojiClick={handleEmojiClick}
                            searchDisabled
                            previewConfig={{
                                showPreview: false,
                                showSkinTones: false
                            }}
                        />
                    </div>
                </ClickAwayListener>
            </Popper>
        </div>
    );
};
export default EmojiPickerButton;
